// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"a9094110","313":"8ee7365b","377":"d82e0b42","816":"20329ffa","913":"b8785660"}[chunkId] + ".chunk.js";
};